import { DRAWER_TYPES } from '@/constants/drawer';
import { ROLES } from '@/constants/roles';

export const eventCreate = {
  path: '/event-create',
  name: 'ui-event-create',
  component: () => import('@/modules/UIDesign/Events/views/event-create/event-create.vue'),
  meta: {
    layout: 'ui-design',
    icon: '$ui-plus',
    title: 'Создание мероприятия',
    accessList: [ROLES.organization, ROLES.event_manager],
    button: true,
    buttonTitle: 'Создать мероприятие',
    children: [
      {
        text: 'Создать с нуля',
        to: '/event-create',
        icon: '$ui-document-plus',
      },
      {
        text: 'Подключиться к существующему',
        to: '/events/market',
        icon: '$ui-link',
      },
      // {
      //   text: 'Выбрать из шаблонов',
      //   to: '/event-create-by-templates',
      //   icon: '$ui-duplicate',
      // },
    ],
  },
};

export const eventCreateByTemplates = {
  path: '/event-create-by-templates',
  name: 'ui-event-create-by-templates',
  component: () => import('@/modules/UIDesign/Events/views/event-create/event-create-by-templates.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Мероприятие из шаблона',
    accessList: [ROLES.organization, ROLES.event_manager],
  },
};

const eventTaskCreateRouteBase = {
  meta: {
    back: true,
    subtitle: true,
    layout: 'ui-design',
    title: 'Добавление задания',
    accessList: [ROLES.organization],
  },
};

const eventTaskEditRouteBase = {
  meta: {
    back: true,
    subtitle: true,
    layout: 'ui-design',
    title: 'Редактирование задания',
    accessList: [ROLES.organization],
  },
};

const eventTaskRouteBase = {
  meta: {
    back: true,
    subtitle: true,
    layout: 'ui-design',
    title: 'Просмотр задания',
    accessList: [ROLES.organization],
  },
};

const eventTaskExploitationRouteBase = {
  meta: {
    back: true,
    subtitle: true,
    layout: 'ui-design',
    isDynamicTitle: true,
    accessList: [ROLES.organization],
  },
};

export const eventsOrganizer = {
  path: '/events-organizer',
  name: 'ui-events-organizer',
  component: () => import('@/modules/UIDesign/Events/views/events-management/events-organizer.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Мои мероприятия',
    accessList: [ROLES.organization],
  },
};

export const eventsSearch = {
  path: '/events-search',
  name: 'ui-events-search',
  component: () => import('@/modules/UIDesign/Events/views/events-search.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Поиск мероприятий',
  },
};

export const widgetEventsSearch = {
  path: '/widget/events-search',
  name: 'ui-events-search-widget',
  component: () => import('@/modules/UIDesign/Events/views/events-search-widget.vue'),
  meta: {
    layout: 'empty',
    title: 'Поиск мероприятий',
  },
};

export default [
  ...(process.env.NODE_ENV === 'development' ? [{
    path: '/dev/nomination-deletion',
    name: 'ui-nomination-deletion-preview',
    component: () => import('@/modules/UIDesign/Events/views/nomination-deletion-preview.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Предпросмотр удаления направления',
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  }] : []),
  eventCreate,
  eventCreateByTemplates,
  eventsOrganizer,
  eventsSearch,
  widgetEventsSearch,
  {
    path: '/event/view/:id/edit',
    name: 'ui-event-landing',
    component: () => import('@/modules/UIDesign/Events/views/event-landing.vue'),
    meta: {
      title: 'Страница мероприятия',
      layout: 'remaked',
      editor: true,
      hideFirstSubdrawer: true,
      subdrawer: DRAWER_TYPES.portal,
      subdrawerCollapsible: true,
      subdrawerWidth: 380,
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  },
  {
    path: '/event-dashboard/:id',
    name: 'ui-event-dashboard',
    component: () => import('@/modules/UIDesign/Events/views/event-dashboard/index.vue'),
    meta: {
      layout: 'ui-design',
      accessList: [ROLES.organization, ROLES.event_manager, ROLES.admin],
    },
    redirect: (to) => ({
      name: 'ui-event-dashboard-main',
      params: {
        id: to.params.id,
      },
    }),
    children: [
      {
        path: 'main',
        name: 'ui-event-dashboard-main',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Управление мероприятием',
          accessList: [ROLES.organization, ROLES.event_manager, ROLES.admin],
          subtitle: true,
        },
      },
      {
        path: 'main-settings',
        name: 'ui-event-dashboard-main-settings',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main-settings.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Настройки мероприятия',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'settings',
        name: 'ui-event-dashboard-settings',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-event-settings.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Редактирование',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'rating',
        name: 'ui-event-dashboard-rating',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-event-rating.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Значимость мероприятия',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'association',
        name: 'ui-event-dashboard-association',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-event-association.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Связь с ассоциацией',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'program-data',
        name: 'ui-event-dashboard-program-data',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-program-data.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Заполнение данных',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'program',
        name: 'ui-event-dashboard-program',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-program.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Программа',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'members',
        name: 'ui-event-dashboard-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-members.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Заявки и участники',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'all-members-filter',
        name: 'ui-event-dashboard-all-members-filter',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-all-members-filter.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Поиск по всем участникам',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'main-organizers',
        name: 'ui-event-dashboard-main-organizers',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main-organizers.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Соорганизаторы',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'templates',
        name: 'ui-event-dashboard-templates',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/dashboard-templates.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Требования к мероприятиям',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'organizers',
        name: 'ui-event-dashboard-organizers',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-organizers.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Управление соорганизаторами',
          subtitle: true,
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'templates-documents',
        name: 'ui-event-dashboard-templates-documents',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/templates-documents.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Передача документов',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'template/:templateEventId',
        name: 'ui-event-dashboard-template-main',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/index.vue'),
        meta: {
          back: true,
          subtitle: true,
          layout: 'ui-design',
          title: 'Шаблон нижестоящего мероприятия',
          accessList: [ROLES.organization],
        },
        children: [
          {
            path: 'settings',
            name: 'ui-event-dashboard-template-settings',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/template-settings.vue'),
            meta: {
              back: true,
              subtitle: true,
              layout: 'ui-design',
              title: 'Редактирование требований',
              accessList: [ROLES.organization],
            },
          },
          {
            path: 'tasks',
            redirect: (to) => ({
              name: 'ui-event-dashboard-templates',
              params: {
                id: to.params.id,
              },
            }),
          },
          {
            ...eventTaskCreateRouteBase,
            path: 'tasks/create',
            name: 'ui-event-dashboard-template-task-create',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/tasks/create.vue'),
            props: (route) => ({
              taskType: route.query.type,
              taskQuestionsType: route.query.questions_type,
              taskFormat: route.query.format,
            }),
            beforeEnter: (to, from, next) => {
              if ([(to.query.type || to.query.questions_type), to.query.format].includes(undefined)) {
                next({
                  name: 'ui-event-dashboard-templates',
                  params: {
                    id: to.params.id,
                  },
                });
                return;
              }

              next();
            },
          },
          {
            ...eventTaskEditRouteBase,
            path: 'tasks/:taskId/edit',
            name: 'ui-event-dashboard-template-task-edit',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/tasks/edit.vue'),
            props: (route) => ({
              taskId: Number(route.params.taskId),
            }),
          },
          {
            ...eventTaskRouteBase,
            path: 'tasks/:taskId',
            name: 'ui-event-dashboard-template-task',
            component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-template/tasks/id.vue'),
            props: (route) => ({
              taskId: Number(route.params.taskId),
            }),
          },
        ],
      },
      {
        path: 'reports',
        name: 'ui-event-dashboard-reports',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-reports.vue'),
        meta: {
          back: true,
          layout: 'ui-design',
          title: 'Отчёты',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'activity-statistics',
        name: 'ui-event-dashboard-activity-statistics',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-activity-statistics.vue'),
        meta: {
          title: 'Статистика активности',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'import-members',
        name: 'ui-event-dashboard-import-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-import-members.vue'),
        meta: {
          title: 'Импорт из списка',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'level-transfer-members',
        name: 'ui-event-dashboard-level-transfer-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-level-transfer-members.vue'),
        meta: {
          title: '',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'tournaments',
        name: 'ui-event-dashboard-tournaments',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/dashboard-tournaments.vue'),
        meta: {
          title: 'Проведение',
          back: true,
          layout: 'ui-design',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'tournament/group/:groupId',
        name: 'ui-event-dashboard-tournament-group',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/dashboard-tournament-group.vue'),
        meta: {
          title: 'Группа',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'tasks',
        redirect: (to) => ({
          name: 'ui-event-dashboard-tournaments',
          params: {
            id: to.params.id,
          },
        }),
      },
      {
        ...eventTaskCreateRouteBase,
        path: 'tasks/create',
        name: 'ui-event-dashboard-tournament-task-create',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/tasks/create.vue'),
        props: (route) => ({
          taskType: route.query.type,
          taskQuestionsType: route.query.questions_type,
          taskFormat: route.query.format,
          tournamentGroupId: route.query[`tournament-group`],
        }),
        beforeEnter: (to, from, next) => {
          if ([(to.query.type || to.query.questions_type), to.query.format, to.query[`tournament-group`]].includes(undefined)) {
            next({
              name: 'ui-event-dashboard-tournaments',
              params: {
                id: to.params.id,
              },
            });
            return;
          }
          next();
        },
      },
      {
        ...eventTaskEditRouteBase,
        path: 'tasks/:taskId/edit',
        name: 'ui-event-dashboard-tournament-task-edit',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/tasks/edit.vue'),
        props: (route) => ({
          taskId: Number(route.params.taskId),
        }),
      },
      {
        ...eventTaskExploitationRouteBase,
        path: 'tasks/:taskId/exploitation',
        name: 'ui-event-dashboard-tournament-task-exploitation',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/tasks/exploitation.vue'),
        props: (route) => ({
          taskId: Number(route.params.taskId),
        }),
      },
      {
        ...eventTaskRouteBase,
        path: 'tasks/:taskId',
        name: 'ui-event-dashboard-tournament-task',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-tournaments/tasks/id.vue'),
        props: (route) => ({
          taskId: Number(route.params.taskId),
        }),
      },
      {
        path: 'main-finish',
        name: 'ui-event-dashboard-main-finish',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-main-finish.vue'),
        meta: {
          title: 'Завершение и награждение',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'subordinate-members',
        name: 'ui-event-dashboard-subordinate-members',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-subordinate-members.vue'),
        meta: {
          title: 'Передача участников',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'formation-certificates',
        name: 'ui-event-dashboard-formation-certificates',
        component: () => import('@/modules/Events/components/certificate-settings/CertificateEdit.vue'),
        meta: {
          float: true,
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'document-constructor',
        name: 'ui-event-dashboard-document-constructor',
        component: () => import('@/modules/UIDesign/DocumentConstructor/views/index.vue'),
        meta: {
          accessList: [ROLES.organization],
          title: 'Настройка грамот',
          layout: 'ui-design',
          back: true,
        },
      },
      {
        path: 'manuals',
        name: 'ui-event-dashboard-manuals',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-manuals.vue'),
        meta: {
          title: 'Методическая поддержка',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'exhibitions',
        name: 'ui-event-dashboard-exhibitions',
        component: () => import('@/modules/UIDesign/Events/views/event-dashboard/dashboard-exhibitions.vue'),
        meta: {
          title: 'Выставки',
          back: true,
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
    ],
  },
];
